import FeeScheduleCalculatorSection from "../fee-schedule-calculator/FeeScheduleCalculatorSection";
import MedicalBreakdownSection from "../medical-breakdown/MedicalBreakdownSection";

export default function RightUpperContainer({ className, targetHeight, variant }) {
  if (variant === "fee-schedule-calculator") {
    return <FeeScheduleCalculatorSection className={className} />;
  }

  return <MedicalBreakdownSection className={className} targetHeight={targetHeight} />;
}
